import {gql} from '@apollo/client'

export default gql`
  query isFavourited($item_type: String!, $item_id: Int!) {
    is_favourited(item_type: $item_type, item_id: $item_id)
  }
`
